import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/PTZ_Tour/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SetPtzPerm';
import PTZTourTable from 'components/Web_User_Interface/1440p_Series/Features/PTZ_Tour/ptzTourTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  PTZTourTable,
  BreadCrumbs,
  SEOHelmet,
  React
};